import * as React from 'react';
import defaultTheme from '@adecco/base-app/src/constants/themes/defaultTheme/defaultTheme';

type Props = {
  className?: string;
};

const InformationIconFilled: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    overflow="visible"
    width="25px"
    height="25px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-0.000000, 0.325112)">
        <path
          d="M12.2192362,0 C8.83381958,0 5.95092604,1.19018521 3.57055562,3.57055562 C1.19018521,5.95092604 0,8.83381958 0,12.2192362 C0,15.6046529 1.1901825,18.4875465 3.57055562,20.8679169 C5.95092604,23.2482873 8.83381958,24.4384725 12.2192362,24.4384725 C15.6046529,24.4384725 18.4875465,23.2482873 20.8679169,20.8679169 C23.2482873,18.4875465 24.4384725,15.6046529 24.4384725,12.2192362 C24.4384725,8.83381958 23.2482873,5.95092604 20.8679169,3.57055562 C18.4875465,1.19018521 15.6046529,0 12.2192362,0 Z"
          fill={defaultTheme.colors.infoIconBackground}
          stroke={defaultTheme.colors.infoIconForeground}
        />
        <path
          d="M12.2192363,18.6462372 C11.5315742,18.6462372 11.1877431,18.3024061 11.1877431,17.6147441 C11.1877431,15.6046516 11.1877431,13.09204 11.1877431,11.5844706 C11.1877431,10.8968085 11.5315742,10.5529775 12.2192363,10.5529775 C12.9068983,10.5529775 13.2507294,10.8968085 13.2507294,11.5844706 C13.2507294,13.5945631 13.2507294,16.1071747 13.2507294,17.6147441 C13.2507294,18.3024061 12.9068983,18.6462372 12.2192363,18.6462372 Z"
          fill={defaultTheme.colors.infoIconForeground}
        />
        <path
          d="M13.2507294,6.85522156 C13.2507294,7.59578281 12.9068983,7.96606344 12.2192363,7.96606344 C11.5315742,7.96606344 11.1877431,7.59578281 11.1877431,6.85522156 C11.1877431,6.16755948 11.5315742,5.82372844 12.2192363,5.82372844 C12.9068983,5.82372844 13.2507294,6.16755948 13.2507294,6.85522156 Z"
          fill={defaultTheme.colors.infoIconForeground}
        />
      </g>
    </g>
  </svg>
);

export default InformationIconFilled;
